import { Checkbox, FormControlLabel } from '@mui/material';
import { MDBox } from 'components/MDBox';
import { MDTypography } from 'components/MDTypography';
import React, { useCallback, useState } from 'react';

type CheckBoxTermOfUseProps = {
  onAgreeChange: (isAgree: boolean) => void;
};

export function CheckBoxTermOfUse({ onAgreeChange }: CheckBoxTermOfUseProps) {
  const [checked, setChecked] = useState(false);

  const onChange = useCallback(() => {
    onAgreeChange(checked);
    setChecked((c) => !c);
  }, [onAgreeChange, checked]);

  return (
    <MDBox display="flex" alignItems="center" ml={-1} style={{ marginTop: 10 }}>
      <Checkbox
        value="agree"
        color="primary"
        onChange={() => onChange()}
        checked={checked}
      />
      <MDTypography color="text" fontSize={12} component="span">
        By registering to FairFare you are agree to the
        <MDTypography
          color="text"
          fontSize={12}
          component="a"
          href={`${location.origin}/terms-of-us`}
          rel="noreferrer"
        >
          &nbsp;Terms Of Use
        </MDTypography>
      </MDTypography>
    </MDBox>
  );
}
